import React from 'react';
import p from './phrases';
import * as e from '../elements';

export default {
  name: 'Contact Form',
  description: 'Simple form for your visitors to send you a message.',
  thumb: 'contact-form',
  tags: ['CTA'],
  jsx: (
    <e.PBlock pad="md">
      <div className="row">
        <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl- 5 col-xxl-4 text-center mb-4 mx-auto">
          <e.PText
            className="my-3" color="black-hi" size="header-h3"
            text={p.contactBlockTitle}
          />
          <e.PText
            className="my-3" color="black-md" size="subheader-md"
            text={p.contactBlockSlogan}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-10 col-lg-8 col-xl-6 mx-auto">
          <e.PForm name="Contact Form">
            <div className="form-group row">
              <e.PText
                className="col-md-3 col-form-label"
                text="Name" size="text-sm"
              />
              <div className="col-md-9">
                <e.PInput name="Name" type="text" className="form-control" placeholder="Your name" />
              </div>
            </div>
            <div className="form-group row">
              <e.PText
                className="col-md-3 col-form-label"
                text="Email" size="text-sm"
              />
              <div className="col-md-9">
                <e.PInput name="Email" type="email" className="form-control" placeholder="Your email" />
              </div>
            </div>
            <div className="form-group row">
              <e.PText
                className="col-md-3 col-form-label"
                text="Message" size="text-sm"
              />
              <div className="col-md-9">
                <e.PInput name="Message" type="textarea" className="form-control" placeholder="Your message" />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-9 offset-md-3">
                <e.PButton
                  size="md" color="primary"
                  isDeletable={false} isSubmit={true}
                  text={p.contactSubmitLabel}
                />
              </div>
            </div>
          </e.PForm>
        </div>
      </div>

    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/ContactForm.jsx